import React from "react";
import PropTypes from "prop-types";

/**
 * SECTION HEADER
 *
 * Handles:
 * - Group or single titles
 * - Automatic display of ID / Group ID
 * - Optional item count (“+X more”)
 * 
 * Usage example:
 * <SectionHeader
 *   title="Wedding Recap"
 *   isGroup={true}
 *   itemCount={3}
 *   primaryId="EVT-1234"
 *   groupId="GRP-5678"
 * />
 */
const SectionHeader = ({
  title = "",
  isGroup = false,
  itemCount = 0,
  eventId = "",
  groupId = "",
  className = "",
  titleClass = "accordion-title accordion-title-color",
  labelClass = "accordion-title",
}) => {
  // Compute title (handles groups and multiple items)
  const renderTitle = () => {
    if (!title) return "No title available";
    if (isGroup && itemCount > 1) {
      return `${title} - ${itemCount} events`;
    }
    return title;
  };

  // Compute ID label and value
  const renderIdSection = () => {
    if (isGroup && groupId) {
      return (
        <>
          <span className={labelClass}>Group Event ID</span>
          <span className={`${titleClass} pl-2`}>{groupId}</span>
        </>
      );
    }

    if (!isGroup && eventId) {
      return (
        <>
          <span className={labelClass}>Event ID</span>
          <span className={`${titleClass} pl-2`}>{eventId}</span>
        </>
      );
    }

    return null;
  };

  return (
    <div
      className={`d-block d-sm-flex justify-content-between align-items-end section-header py-2 ${className}`}
    >
      <div className={titleClass}>{renderTitle()}</div>
      <div>{renderIdSection()}</div>
    </div>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string,
  isGroup: PropTypes.bool,
  itemCount: PropTypes.number,
  eventId: PropTypes.string,
  groupId: PropTypes.string, 
  className: PropTypes.string,
  titleClass: PropTypes.string,
  labelClass: PropTypes.string,
};

export default SectionHeader;
